<template>
  <v-simple-table class="tabela-titulos" dense>
    <thead>
    <tr>
      <th>{{ ehCheque ? 'Nº Cheque' : 'Título' }}</th>
      <th>{{ ehCheque ? 'Seq.' : 'Dígito' }}</th>
      <th>Vencimento</th>
      <th class="text-right">Saldo</th>
      <th class="text-right">Juros Mora</th>
      <th class="text-right">Valor Atualizado</th>
      <th class="text-center">Situação</th>
      <th>Data Situação</th>
    </tr>
    </thead>

    <tbody>
    <tr v-if="carregando">
      <td colspan="8"><v-skeleton-loader light type="table-row" /></td>
    </tr>

    <template v-else>
      <tr v-for="(item, index) in baixaveis" :key="`b-${index}`">
        <td>{{ item.titulo }}</td>
        <td>{{ item.digitotitulo }}</td>
        <td>{{ item.dtvencimento | formataData }}</td>
        <td class="text-right">{{ item.saldotitulo | formataDinheiro }}</td>
        <td class="text-right">{{ item.jurosmora | formataDinheiro }}</td>
        <td class="text-right">{{ item.valoratualizado | formataDinheiro }}</td>
        <td class="text-center">
          <v-chip x-small label outlined :color="ehCheque ? 'red darken-3' : 'primary'" class="font-weight-bold">
            {{ rotuloSituacao(item.situacao) }}
          </v-chip>
        </td>
        <td>{{ item.dtmovimento | formataData }}</td>
      </tr>

      <template v-if="pendentes.length > 0">
        <tr class="linha-grupo">
          <td colspan="8">
            <v-icon x-small color="orange darken-2" class="mr-1">mdi-alert</v-icon>
            Não devolvidos pela filial (não entram na baixa)
          </td>
        </tr>
        <tr v-for="(item, index) in pendentes" :key="`p-${index}`" class="linha-pendente">
          <td>{{ item.titulo }}</td>
          <td>{{ item.digitotitulo }}</td>
          <td>{{ item.dtvencimento | formataData }}</td>
          <td class="text-right">{{ item.saldotitulo | formataDinheiro }}</td>
          <td class="text-right">{{ item.jurosmora | formataDinheiro }}</td>
          <td class="text-right">{{ item.valoratualizado | formataDinheiro }}</td>
          <td class="text-center">
            <v-chip x-small label color="orange darken-2" class="white--text font-weight-bold">
              {{ rotuloSituacao(item.situacao) }}
            </v-chip>
          </td>
          <td>{{ item.dtmovimento | formataData }}</td>
        </tr>
      </template>
    </template>
    </tbody>

    <tfoot v-if="!carregando && titulos.length > 0">
    <tr>
      <td colspan="3" class="font-weight-bold">
        Total a baixar ({{ baixaveis.length }})
      </td>
      <td class="text-right font-weight-bold">{{ somar(baixaveis, 'saldotitulo') | formataDinheiro }}</td>
      <td class="text-right font-weight-bold">{{ somar(baixaveis, 'jurosmora') | formataDinheiro }}</td>
      <td class="text-right font-weight-bold">{{ somar(baixaveis, 'valoratualizado') | formataDinheiro }}</td>
      <td colspan="2"></td>
    </tr>
    <tr v-if="pendentes.length > 0" class="orange--text text--darken-3">
      <td colspan="3" class="font-weight-bold">
        Não devolvidos ({{ pendentes.length }})
      </td>
      <td class="text-right font-weight-bold">{{ somar(pendentes, 'saldotitulo') | formataDinheiro }}</td>
      <td class="text-right font-weight-bold">{{ somar(pendentes, 'jurosmora') | formataDinheiro }}</td>
      <td class="text-right font-weight-bold">{{ somar(pendentes, 'valoratualizado') | formataDinheiro }}</td>
      <td colspan="2"></td>
    </tr>
    </tfoot>
  </v-simple-table>
</template>

<script>
const ROTULOS = {
  'DEVOLVIDO': 'Devolvido',
  'EM ABERTO': 'Em aberto',
  'EM CARTEIRA': 'Em carteira',
  'CUSTODIA': 'Em custódia',
  'REAPRESENTADO': 'Reapresentado',
};

export default {
  name: "CreduTitulosTabela",
  props: {
    titulos: { type: Array, default: () => [] },
    carregando: { type: Boolean, default: false },
  },
  computed: {
    ehCheque() {
      return this.titulos.length > 0 && this.titulos[0].tipo === 'CHEQUE';
    },
    baixaveis() {
      return this.titulos.filter(v => v.baixavel);
    },
    pendentes() {
      return this.titulos.filter(v => !v.baixavel);
    },
  },
  methods: {
    rotuloSituacao(situacao) {
      return ROTULOS[situacao] || situacao;
    },
    somar(lista, campo) {
      return lista.reduce((a, v) => a + (v[campo] || 0), 0);
    },
  },
};
</script>

<style scoped>
.tabela-titulos {
  margin: 0 0 10px 0;
  border-radius: 0;
}

.tabela-titulos thead th {
  background-color: #CFD8DC !important;
  height: 30px !important;
  white-space: nowrap;
}

.tabela-titulos tbody td,
.tabela-titulos tfoot td {
  height: 28px !important;
  white-space: nowrap;
}

.tabela-titulos tfoot tr {
  background-color: #ECEFF1;
}

.linha-grupo td {
  background-color: #FFF3E0;
  color: #E65100;
  font-weight: bold;
  font-size: 0.75rem !important;
}

.linha-pendente td {
  color: #9E9E9E;
}
</style>
